import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useYear } from '../contexts/YearContext';
import YearSelectionComponent from '../components/YearSelectionComponent';

const YearSelectionPage: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const { currentYear } = useYear();

    // Get return path from location state
    const returnPath = location.state?.returnPath || '/home';

    useEffect(() => {
        // If year is selected, redirect to the return path
        if (currentYear) {
            history.push(returnPath);
        }
    }, [currentYear, history, returnPath]);

    return (
        <div className="year-selection-page">
            <YearSelectionComponent />
        </div>
    );
};

export default YearSelectionPage; 